import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import FormCheckboxField from '@adv-mt/mt-form-checkbox-field'

const LEGACY_WRAPPER = 'legacy'
const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'

const FormHasStock = ({id, value, onChange, type, wrapper = LEGACY_WRAPPER}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {checked}) => {
    setTimeout(
      () =>
        onChange(e, {
          field: FILTER_NAMES.HAS_STOCK,
          value: checked,
          lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.HAS_STOCK]
        }),
      0
    )
  }

  const handleChecked = ({value: selectedValue}) => {
    const [currentValue] = selectedValue

    _handleOnChange(null, {checked: currentValue === CHECKED_ID})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <FormCheckboxField
        checked={value}
        id={id || FILTER_NAMES.HAS_STOCK}
        helpText={i18n.t('FORM.HAS_STOCK_DESCRIPTION')}
        label={i18n.t('COMMON.HAS_STOCK')}
        onChange={_handleOnChange}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          name: FILTER_NAMES.HAS_STOCK,
          options: [{id: CHECKED_ID, label: i18n.t('COMMON.HAS_STOCK')}],
          type
        }
      ]}
      group={`${FILTER_NAMES.HAS_STOCK}Group`}
      helpText={i18n.t('FORM.HAS_STOCK_DESCRIPTION')}
      legend={i18n.t('COMMON.HAS_STOCK')}
      onChange={handleChecked}
      value={{[FILTER_NAMES.HAS_STOCK]: [value ? CHECKED_ID : UNCHECKED_ID]}}
      wrapper={wrapper}
    />
  )
}

FormHasStock.displayName = 'FormHasStock'
FormHasStock.propTypes = {
  id: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  wrapper: PropTypes.string
}

export default FormHasStock
